<template>
  <b-input
    ref="inputRef"
    :value="formattedValue"
    :error-message="errorMessage"
    :error="!!errorMessage"
    outlined
    size="sm"
    class="text-right"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'
import { computed, watch } from 'vue'
import { watchDebounced } from '@vueuse/core'

export default {
  name: 'QCurrencyInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { inputRef, formattedValue, numberValue, setValue, setOptions } = useCurrencyInput(
      { currency: props.currency },
      false
    )

    const errorMessage = computed(() =>
      numberValue.value <= 100 ? 'Value must be greater than 100' : undefined
    )

    watch(
      () => props.value,
      (value) => {
        setValue(value)
      }
    )

    watch(
      () => props.currency,
      (currency) => {
        setOptions({ currency })
      }
    )

    watchDebounced(numberValue, (value) => emit('input', value), {
      debounce: 1000,
    }) // Vue 2: emit('input', value)

    return { inputRef, formattedValue, errorMessage }
  },
}
</script>
